import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { FirstTimeIntro } from "../components";
import { useCheckInData } from "../hooks";

export function CheckInWelcomePage() {
	const { user } = useAuth();
	const navigate = useNavigate();
	const { totalCheckInsCount, reflections, loading } = useCheckInData(user?.id);

	const handleCreateCheckIn = () => {
		navigate("/daily-checkin");
	};

	const handleCreateReflection = () => {
		navigate("/reflection/new");
	};

	if (!user || loading) {
		return (
			<div className="container mx-auto px-4 py-8">
				<div className="flex items-center justify-center h-64">
					<div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
			<div className="container mx-auto px-4 py-6 sm:py-8 max-w-7xl">
				<FirstTimeIntro
					totalCheckInsCount={totalCheckInsCount || 0}
					hasReflections={reflections.length > 0}
					onCreateCheckIn={handleCreateCheckIn}
					onCreateReflection={handleCreateReflection}
				/>
			</div>
		</div>
	);
}
